import { Alert, AlertLevel } from '@vizit/atoms';

enum SsoLoginError {
  GenericError = 'sso_generic_error',
  InvalidCredentials = 'invalid_credentials',
  UserNotFound = 'user_not_found',
  InvalidState = 'invalid_state',
  AuthFailed = 'auth_failed',
  SessionExpired = 'session_expired',
}

interface SsoErrorAlertProps {
  /**
   * The SSO error type to display.
   *
   * @required
   * @type {SsoLoginError}
   */
  error: SsoLoginError;
}

const ERROR_MESSAGES: Record<SsoLoginError, string> = {
  [SsoLoginError.GenericError]: 'Something went wrong. Please try again.',
  [SsoLoginError.InvalidCredentials]: 'Invalid email or password.',
  [SsoLoginError.UserNotFound]: 'Account setup required. Please contact your Vizit admin.',
  [SsoLoginError.InvalidState]: 'Your login session has expired. Please try again.',
  [SsoLoginError.AuthFailed]: 'Authentication failed. Please try again.',
  [SsoLoginError.SessionExpired]: 'Session expired. Please log in again.',
};

function SsoErrorAlert(props: SsoErrorAlertProps) {
  const { error } = props;
  const message = ERROR_MESSAGES[error] ?? ERROR_MESSAGES[SsoLoginError.GenericError];

  return (
    <Alert className="animate-fade-in" level={AlertLevel.Error}>
      <Alert.Description>{message}</Alert.Description>
    </Alert>
  );
}

export { SsoErrorAlert, SsoLoginError };
export type { SsoErrorAlertProps };
